import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPassword } from '../redux/modules/user/actions';
import CommonAuthComponent from './CommonAuthComponent';
import CustomInput from '../components/common/CustomInput';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { forgotPasswordLoading } = useSelector((state) => state.users);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (email) {
      dispatch(forgotPassword(email, navigate));
    }
  };

  return (
    <CommonAuthComponent>

      {/* Heading */}
      <h1 className="text-[22px] text-center mb-8 font-medium leading-[30px]">
        Forgot Your Password?
      </h1>

      {/* Description Text */}
      <p className="text-center text-[16px] font-normal leading-[22px]">
        Enter your Email Address and we will send you instructions to reset your password.
      </p>

      {/* Email Form */}
      <form onSubmit={handleSubmit}>
        <CustomInput
          label="Email Address"
          placeholder="Enter Email Address"
          inputClassName="bg-transparent"
          name="email"
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className='bg-white mb-[32px] mt-[46px]'
        />

        <button
          type="submit"
          disabled={forgotPasswordLoading}
          className="w-full inline-flex disabled:opacity-50 rounded-[4px] border transition-all duration-300 text-body-lg items-center font-semibold justify-center px-6 py-3.5
            bg-REELTeal border border-transparent hover:bg-teal-200 text-white"
        >
          {forgotPasswordLoading ? (
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
          ) : null}
          {forgotPasswordLoading ? 'Sending...' : 'Send Email'}
        </button>
      </form>

      {/* Back to Login section commented out as requested */}
      <div className="mt-4 text-center">
        <button
          type="button"
          onClick={() => navigate('/login')}
          className="w-full inline-flex disabled:opacity-50 rounded-[4px] border-[1px] border-REELTeal transition-all duration-300 text-body-lg items-center font-semibold justify-center px-6 py-3.5 hover:bg-teal-75"
        >
          Back to Log-In
        </button>
      </div>
    </CommonAuthComponent>
  );
};

export default ForgotPassword;
